import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#category', label: '题材分类' },
  { href: '#hot', label: '热门连载' },
  { href: '#guoman', label: '国漫专区' },
  { href: '#riman', label: '日漫专区' },
  { href: '#classic', label: '经典全本' },
  { href: '#faq', label: '常见问题' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="虫虫漫画首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl transition-colors ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-600'
            }`}
          >
            <i className="ri-bug-2-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl transition-colors ${
              solid ? 'text-foreground-950' : 'text-white'
            }`}
          >
            虫虫漫画
          </span>
        </a>

        {/* 桌面导航 */}
        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  solid
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
          <li className="ml-2">
            <a
              href="#about"
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold transition-colors ${
                solid
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/95 text-primary-600 hover:bg-white'
              }`}
            >
              关于我们
            </a>
          </li>
        </ul>

        {/* 移动端菜单按钮 */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          aria-expanded={open}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden transition-colors ${
            solid ? 'text-foreground-900 hover:bg-background-100' : 'text-white hover:bg-white/10'
          }`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </nav>

      {/* 移动端菜单面板 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-3 text-base text-foreground-800 hover:bg-background-100 hover:text-primary-600"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#about"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-base font-semibold text-background-50 hover:bg-primary-600"
              >
                关于我们
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}